import React from 'react';
import PropTypes from 'prop-types';

import {
  REQUESTED_AT_IN_FUTURE,
  cancel_bucket_label,
  derive_cancel_bucket,
  is_requested_at_in_future
} from './bucket_rules';

// PROD-7828 D4 (decision 2026-10-07): the request time is the only input; the category is derived and read-only.
// Without onRequestedAtChange the host owns the time field (Care draft "Requested at (IST)") and this shows only the category.
function TeacherCancelBucketPicker(props) {
  const {
    requestedAt,
    onRequestedAtChange,
    sessionStartEpoch,
    ianaTimezone,
    timezoneLabel,
    error,
    timeFieldNote,
    categoryNote
  } = props;
  const ownsTimeField = typeof onRequestedAtChange === 'function';
  const bucket = derive_cancel_bucket(sessionStartEpoch, requestedAt, ianaTimezone);
  const category = cancel_bucket_label(bucket);
  // capture mode: the Care draft field reports its own future-time error
  const inFuture = ownsTimeField && is_requested_at_in_future(requestedAt, ianaTimezone, Date.now());

  const heading_id = 'tp-cancel-bucket-heading';
  const category_id = 'tp-cancel-bucket-category';
  const time_label = `Requested at (${timezoneLabel || ianaTimezone})`;
  return (
    <div role="group" aria-labelledby={heading_id} style={{ margin: '10px 0' }}>
      <div id={heading_id} style={{ fontWeight: 600, marginBottom: '6px' }}>
        When did the teacher request this cancellation?
      </div>
      {ownsTimeField ? (
        <div style={{ marginBottom: '6px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }} htmlFor="tp-cancel-bucket-time">
            {time_label} (required)
          </label>
          <input
            id="tp-cancel-bucket-time"
            type="datetime-local"
            value={requestedAt || ''}
            onChange={(e) => onRequestedAtChange(e.target.value)}
            aria-required="true"
            aria-invalid={error || inFuture ? 'true' : 'false'}
            aria-describedby={category_id}
            style={{ width: '300px', maxWidth: '100%' }}
          />
        </div>
      ) : null}
      <div id={category_id} role="status" data-testid="tp-cancel-bucket-category">
        Category: {category || `set from the request time${ownsTimeField ? '' : ` (${timeFieldNote})`}`}
        {category && categoryNote ? ` (${categoryNote})` : ''}
      </div>
      {inFuture ? <p style={{ color: 'var(--state-error)' }}>* {REQUESTED_AT_IN_FUTURE}.</p> : null}
      {error && !inFuture ? (
        <p style={{ color: 'var(--state-error)' }}>
          * Enter when the teacher requested this cancellation ({time_label}). Use your best estimate if unsure.
        </p>
      ) : null}
    </div>
  );
}

TeacherCancelBucketPicker.propTypes = {
  requestedAt: PropTypes.string,
  onRequestedAtChange: PropTypes.func,
  sessionStartEpoch: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ianaTimezone: PropTypes.string,
  timezoneLabel: PropTypes.string,
  error: PropTypes.bool,
  timeFieldNote: PropTypes.string,
  categoryNote: PropTypes.string
};

TeacherCancelBucketPicker.defaultProps = {
  requestedAt: '',
  onRequestedAtChange: undefined,
  sessionStartEpoch: undefined,
  ianaTimezone: 'Asia/Kolkata',
  timezoneLabel: 'IST',
  error: false,
  timeFieldNote: 'enter "Requested at (IST)" below',
  categoryNote: ''
};

export default TeacherCancelBucketPicker;
